module.exports = __webpack_public_path__ + "img/og.11b0901d.jpg";